import { modifyUrlQuery } from '@/utils';

export type GetProperImageUrl = (image?: {
  contentType?: string | undefined;
  url?: string | undefined;
  [key: string]: any;
}) => string;

type CreateGetProperImageUrl = (isWebpSupported: boolean) => GetProperImageUrl;

const WEBP_CONTENT_TYPE = 'image/webp';
const SVG_CONTENT_TYPE = 'image/svg+xml';

export const createGetProperImageUrl: CreateGetProperImageUrl = (isWebpSupported) => (image) => {
  if (!image?.url) return '';

  const { contentType, url } = image;

  if (contentType === SVG_CONTENT_TYPE) {
    const hasQuery = url.includes('?');

    return hasQuery ? (url.split('?').shift() as string) : url;
  }

  if (isWebpSupported) {
    if (contentType === WEBP_CONTENT_TYPE) {
      return url;
    }

    return modifyUrlQuery(url, (prevQuery) => {
      return {
        ...(prevQuery as Record<string, any>),
        fm: 'webp',
      };
    });
  }

  if (!contentType || contentType === WEBP_CONTENT_TYPE) {
    return modifyUrlQuery(url, (prevQuery) => {
      return {
        ...(prevQuery as Record<string, any>),
        fm: 'png',
      };
    });
  }

  return url;
};
